// usp accordion
export default function initAccordion() {
	var accordionTitle = document.querySelectorAll(".accordion__header");

	for (var i = 0; i < accordionTitle.length; i++) {
		accordionTitle[i].addEventListener("click", openCurrAccordion);
	}

	function openCurrAccordion(e) {
		for (var i = 0; i < accordionTitle.length; i++) {
			var parent = accordionTitle[i].parentElement;
			var nextAccordion = accordionTitle[i].nextElementSibling;

			if (this === accordionTitle[i] && !parent.classList.contains("open")) {
				parent.classList.add("open");
				nextAccordion.style.maxHeight = nextAccordion.scrollHeight + "px";
				nextAccordion.style.margin = "1rem 0";
			} else {
				parent.classList.remove("open");
				nextAccordion.style.maxHeight = "0px";
				nextAccordion.style.margin = "0";
			}
		}
	}

	const links = document.querySelectorAll(".js-category");
	links.forEach(function (elem) {
		elem.addEventListener("click", smoothScroll);
	});

	function smoothScroll(e) {
		// Prevent default anchor behaviour
		e.preventDefault();
	const links = document.querySelectorAll(".js-category");
	links.forEach(function (elem) {
		elem.classList.remove('active');
	});
		this.classList.add('active');
		// Get clicked links href attribute
		const link = this.getAttribute("href");

		// Get the targets position
		const offsetTop = document.querySelector(link).offsetTop;

		// Finally scroll to target
		scroll({
			top: offsetTop,
			behavior: "smooth",
		});
	}
}
